import { type TaskAgentMessagesResponse } from "@/src/app/api/tasks/[taskId]/agent-run/messages/route";
import { type TaskAgentRunResponse } from "@/src/app/api/tasks/[taskId]/agent-run/route";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getTaskAgentRun(taskId: string): Promise<TaskAgentRunResponse> {
  return fetchJSON(`/api/tasks/${taskId}/agent-run`);
}

export async function getTaskAgentMessages(taskId: string): Promise<TaskAgentMessagesResponse> {
  return fetchJSON(`/api/tasks/${taskId}/agent-run/messages`);
}
